// ABOUTME: Page-level stagger animation container and child wrapper
// ABOUTME: Orchestrates entrance animations for page sections

import { motion } from 'framer-motion'
import type { ReactNode } from 'react'
import { easing } from '@/lib/utils/animations'

const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05,
    },
  },
}

const childVariants = {
  hidden: { opacity: 0, y: 16 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.35,
      ease: easing.enter,
    },
  },
}

interface PageTransitionProps {
  children: ReactNode
  className?: string
}

export function PageTransition({ children, className }: PageTransitionProps) {
  return (
    <motion.div variants={containerVariants} initial="hidden" animate="show" className={className}>
      {children}
    </motion.div>
  )
}

interface StaggerChildProps {
  children: ReactNode
  className?: string
}

export function StaggerChild({ children, className }: StaggerChildProps) {
  return (
    <motion.div variants={childVariants} className={className}>
      {children}
    </motion.div>
  )
}
